/**
 * Polling helpers to stop background tabs from hammering the API.
 *
 * Apollo's `pollInterval` fires on a fixed timer regardless of whether the tab
 * is visible, so every open (even minimized / forgotten) tab keeps polling the
 * API forever. `skipPollAttempt` is invoked by Apollo before each poll tick;
 * returning `true` skips that tick without cancelling the timer, so polling
 * transparently resumes as soon as the tab becomes visible again.
 *
 * Usage:
 *   const { data } = useActiveOrdersQuery({
 *     pollInterval: 15000,
 *     skipPollAttempt: skipPollWhenHidden,
 *   });
 */
export const skipPollWhenHidden = (): boolean => {
	// document may be undefined in non-browser (SSR / test) environments.
	if (typeof document === "undefined") {
		return false;
	}

	return document.visibilityState === "hidden";
};
